module.exports = __webpack_public_path__ + "images/moonshot/wave.f38b4ca64b6fb83c6d98.svg";